import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Get status
 * @returns {JSX.Element}
 */
const CourseListItemVenue = ({ venues }) => {
	return (
		<div className="upcoming-event-list__item__venue">
			{venues.map((venue, index) => (
				<span key={`${venue?.id}-${venue?.slug}-${index}`}>
					{decodeEntities(venue?.name)}
				</span>
			))}
		</div>
	);
};

export default CourseListItemVenue;
